















import { SfLoader } from "@storefront-ui/vue";
import {
  defineComponent,
  ref,
  useFetch,
  useContext,
  useRoute,
  onMounted,
} from "@nuxtjs/composition-api";
import { useCache, CacheTagPrefix } from "@vue-storefront/cache";
import { getMetaInfo } from "~/helpers/getMetaInfo";
import { useContent, useGtm } from "~/composables";
import { CmsPage } from "~/modules/GraphQL/types";
import PageBuilder from "~/components/PageBuilder/PageBuilder.vue";
import { usePageStore } from '~/stores/page';
import { assign, trimEnd } from "lodash-es";

export default defineComponent({
  name: "CmsPage",
  components: {
    PageBuilder,
    SfLoader,
    Banner: () => import("~/components/General/Banner.vue"),
  },
  setup() {
    const { app: { i18n }, $config } = useContext();
    const route = useRoute();
    const pageStore = usePageStore();
    const { eventPageLoad } = useGtm();
    const { addTags } = useCache();
    const { error: nuxtError } = useContext();
    const bannerData = ref({});
    const { loadCmsPage, loading, error } = useContent();
    const isServer = () => typeof window === `undefined`;
    const serverGet = ref(false);

    const page = ref<CmsPage | null>(null);

    const pageIdentifier = "home";

    useFetch(async () => {
      if (isServer) {
        serverGet.value = true;
      }
      const data = await loadCmsPage({
        identifier: pageIdentifier,
      });
      bannerData.value = {
        imgUrl: data["top_banner_background_image"] ?? "",
        subTitle: data["subtitle"] ?? "",
        shortDescription: data["short_description"] ?? "",
      };
      page.value = assign(data, {
        pageTitle: data['page_title'],
        metaDescription: data['meta_description'],
        pageUrl: trimEnd($config.baseUrl, '/') + route.value.path,
        // pageImage: data['top_banner_background_image'] ?? undefined,
      });
      if (error?.value?.page || !page.value) nuxtError({ statusCode: 404 });

      addTags([{ prefix: CacheTagPrefix.View, value: pageIdentifier }]);

      pageStore.$patch((state) => {
        state.pageData = assign(state.pageData, {
          pageName: i18n.t('Home'),
          pageTitle: page.value['page_title'],
          pageCategory: i18n.t('Home'),
          breadCrumbs: [i18n.t('Home')],
        });
      });
      if (!isServer()) {
        eventPageLoad();
      }
    });

    onMounted(() => {
      if (!serverGet.value) {
        eventPageLoad();
      }
    });

    return {
      page,
      loading,
      bannerData,
    };
  },
  head() {
    return getMetaInfo(this.page);
  },
  mounted() {
    // Remove all old body classes
    document.body.classList.forEach((element) => {
      if (element !== "show-hero-img") {
        document.body.classList.remove(element);
      }
    });

    // Set current page level and header render for html body element
    document.body.classList.add("homepage");
    document.body.classList.add("page-header-primary");
  },
  updated() {
    // Remove all old body classes
    document.body.classList.forEach((element) => {
      if (element !== "show-hero-img") {
        document.body.classList.remove(element);
      }
    });

    // Set current page level and header render for html body element
    document.body.classList.add("homepage");
    document.body.classList.add("page-header-primary");
  },
});
